import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { editClientDetails } from "store/client/actions";

function useModalLogic(clientId) {
  const [open, setOpen] = useState(false);
  const { editSuccess, updating } = useSelector((state) => state.clientReducer);
  const dispatch = useDispatch();

  const toggleModal = () => {
    setOpen(!open);
  };

  const handleClientAction = (values) => {
    dispatch(editClientDetails({
      values,
      id: clientId
    }));
  };

  useEffect(() => {
    if (editSuccess && open) {
      toggleModal();
    }
  }, [editSuccess]);

  return {
    open,
    toggleModal,
    handleClientAction,
    updating,
  };
}

export default useModalLogic;